import { getDevSettingsFromUrl } from '../devSettings/getDevSettingsFromUrl';
import { setStoredDevSettings } from '../devSettings/setStoredDevSettings';

export const initializeDevSettingsFromUrl = (): void => {
  const settings = getDevSettingsFromUrl({ search: window.location.search });

  if (!settings) {
    return;
  }

  setStoredDevSettings({
    settings,
  });
};
